/**
 * This code was GENERATED using the solita package.
 * Please DO NOT EDIT THIS FILE, instead rerun solita to update it or write a wrapper to add functionality.
 *
 * See: https://github.com/metaplex-foundation/solita
 */

import * as beet from "@metaplex-foundation/beet";
import * as web3 from "@solana/web3.js";
import * as beetSolana from "@metaplex-foundation/beet-solana";
import { BidAsset, bidAssetBeet } from "./BidAsset";
export type UpdateConfigArgs = {
  targetAssetAllocationAmount: beet.COption<beet.bignum>;
  targetAssetMint: beet.COption<web3.PublicKey>;
  targetAssetDecimals: beet.COption<number>;
  targetTicketAmount: beet.COption<beet.bignum>;
  minTicket: beet.COption<beet.bignum>;
  maxTicket: beet.COption<beet.bignum>;
  duration: beet.COption<beet.bignum>;
  whitelistDuration: beet.COption<beet.bignum>;
  bonusDuration: beet.COption<beet.bignum>;
  bonusMinTicketIncrease: beet.COption<beet.bignum>;
  bonusSellOutEligibleTokenPer: beet.COption<beet.bignum>;
  bonusSellOutBonusTokenPer: beet.COption<beet.bignum>;
  walletMaxTicketCap: beet.COption<beet.bignum>;
  isStopped: boolean;
  bidAssets: BidAsset[];
};

/**
 * @category userTypes
 * @category generated
 */
export const updateConfigArgsBeet = new beet.FixableBeetArgsStruct<UpdateConfigArgs>(
  [
    ["targetAssetAllocationAmount", beet.coption(beet.u128)],
    ["targetAssetMint", beet.coption(beetSolana.publicKey)],
    ["targetAssetDecimals", beet.coption(beet.u8)],
    ["targetTicketAmount", beet.coption(beet.u128)],
    ["minTicket", beet.coption(beet.u128)],
    ["maxTicket", beet.coption(beet.u128)],
    ["duration", beet.coption(beet.i64)],
    ["whitelistDuration", beet.coption(beet.i64)],
    ["bonusDuration", beet.coption(beet.i64)],
    ["bonusMinTicketIncrease", beet.coption(beet.u128)],
    ["bonusSellOutEligibleTokenPer", beet.coption(beet.u128)],
    ["bonusSellOutBonusTokenPer", beet.coption(beet.u128)],
    ["walletMaxTicketCap", beet.coption(beet.u128)],
    ["isStopped", beet.bool],
    ["bidAssets", beet.array(bidAssetBeet)],
  ],
  "UpdateConfigArgs"
);
